const TetherCnt = {
  symbol: "usdt",
  name: "tether",
  meta: {
    title: "Buy Tether | Sell Tether | Tether prices and charts",
    description:
      "Tether is the most famous Stable Queen market. Tetra is backed by the US dollar and is always priced at one dollar. Buy and sell Tetra at the best price, lowest commission and fastest time in coinnik Market.",
    keywords: "Tether, buy Tether, sell Tether, Tether price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه تتر بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید تتر کنید. قیمت تتر در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول تتر کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "امن‌ترین راه برای ذخیره تتر یک کیف پول سخت‌افزاری است. کیف پول سخت‌افزاری سرمایه شما را آفلاین نگه می‌دارد و سرقت آن‌ها را غیرممکن می‌کند، مگر اینکه کسی به عبارات بازیابی کیف پول شما دسترسی داشته باشد. بهترین کیف پول‌های تتر عبارتند از: کیف پول سخت‌افزاری لجر (Ledger) و ترزور (Trezor)، کیف پول موبایل تراست (Trust)، کوینومی () و اکسودوس (Exodus)، کیف پول‌های تحت وب متامسک (Metamask)  و کوین نیک مارکت.",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین نیک مارکت می‌توانم تتر نگهداری کنم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " در کوین‌نیک مارکت یک کیف پول اختصاصی و امن دارید، که می‌توانید تترتان را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت. ",
        },
      },
      {
        "@type": "Question",
        name: "آیا تتر ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "بهترین استفاده تتر این است که به عنوان راهی برای حفظ سرمایه از آن استفاده کنیم یا برای انتقال سریع دلار به صورت دیجیتالی. مثلا وقتی شما احساس می‌کنید که قیمت یک ارز دیجیتال که شما مالک آن هستید، به صورت ناپایداری بالاست. در این حالت بهترین اقدام این است که آن را به تتر تبدیل کنید، سپس منتظر افت قیمت یا سقوط برای خرید دوباره آن رمز ارز باشید. داشتن تتر به شما کمک می‌کند تا به سرعت ارز دیجیتال مورد نظر خود را خریداری کنید. از طرفی برای انتقال سریع دلار، ارسال تتر یکی از بهترین راه‌هاست.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy Tether",
      answer:
        "In coinnik Market trading platform, you can buy Tether with Shetab member bank card and the lowest fee. The price of tether in Quinnic Market is determined by you.",
      id: "toggler1",
    },
    {
      question: "What is the best Tether wallet?",
      answer: "Tether_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a tether at coinnik Market?",
      answer: "Keep_tether_description",
      id: "toggler3",
    },
    {
      question: "Is tether worth the investment?",
      answer: "Tether_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about Tether",
        subTitle: "What is Tether?",
        content: "Tether_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of Tether",
        content: "Tether_history_description",
        btnTitle: "Buy and sell Tether",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Buy and sell Teter without intermediaries in Quinnic Market",
        subTitle: "Buy Tether",
        content: "Buy_Tether_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell Tether",
        content: "Sell_Tether_description",
        btnTitle: "Buy and sell Tether",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest Tether analysis on the blog",
  informationTitle: "Tether market statistics and information",
};

export default TetherCnt;
